import script from "./WeekText.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeekText.vue?vue&type=script&setup=true&lang=ts"

import "./WeekText.vue?vue&type=style&index=0&id=6aefce07&lang=css"

const __exports__ = script;

export default __exports__